export default "__VITE_ASSET__DcLRPbZB__"